/**
 * Нормализация и проверка телефонов RU (+7) и BY (+375).
 * Для РБ допустимы только мобильные коды 24 / 25 / 29 / 33 / 44.
 * Валидация идёт по цифрам после снятия скобок, пробелов и дефисов —
 * иначе отформатированный белорусский номер не проходит regex для +7.
 */

const BY_OPERATOR_CODES = '24|25|29|33|44';

export function normalizePhone(val) {
  if (!val) return '';
  return String(val).replace(/[()\-\s]/g, '');
}

export function isValidRuByPhone(val) {
  const phone = normalizePhone(val);
  return (
    /^\+?7\d{10}$/.test(phone) ||
    /^\+?8\d{10}$/.test(phone) ||
    new RegExp(`^\\+?375(${BY_OPERATOR_CODES})\\d{7}$`).test(phone)
  );
}
